<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .info-heading {
    display: flex;
    align-items: center;
    @include colors.background-color(interfaceSwGrey_5);
    height: utils.in_rem(54px);
    width: 100%;
    padding: 1rem 2rem;

    .info-heading-group {
      display: flex;
      justify-content: space-between;
      width: 100%;
      overflow-x: hidden;

      .info-heading-group-left {
        display: flex;
        align-items: center;

        white-space: nowrap;

        min-width: 0;
        flex: 1;

        @include mixins.h4();

        .campaign-status {
          @include colors.color(textGrey);
          margin-right: 0.5rem;
        }
        .campaign-link {
          @include colors.color(primary_50);
          overflow: hidden;
          text-overflow: ellipsis;

          min-width: 0;

          &:hover {
            @include colors.color(primary_70);
          }
        }

        .no-campaign {
          @include colors.color(textGrey);
          overflow: hidden;
          text-overflow: ellipsis;

          min-width: 0;
        }

        .to-do-step {
          @include colors.color(textGrey);
        }
      }

      .info-heading-group-right {
        display: flex;
        align-items: center;
        flex-shrink: 0;

        margin-left: 1rem;

        span {
          @include colors.color(textGrey);
          @include mixins.body2();
          &.overdue {
            @include colors.color(systemError_100);
          }
          &.snoozed-on-span {
            margin-left: 0.5rem;
          }
        }
      }

      .separator {
        padding: utils.in_rem(12px) 0;
        margin: 0 0.5rem;

        height: 100%;
        border: 0.5px solid colors.get(interfaceTransparentBlack_6);
      }
    }
  }
</style>

<script>
  // Stores
  import { todosModalItemStore as toDo } from "./stores";
  // Utils
  import { numericDateString } from "../../../../assets/js/src/general/utils";
  import { formatDate } from "./utils";
  // Components
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";

  $: isBounce = $toDo.kind === "bounce";
  $: isOpportunity = $toDo.kind === "opportunity";
  $: isAiToDo = $toDo.kind === "aiToDo";
  $: isManualToDo = $toDo.kind === "manualToDo";

  $: renderStepInfo = $toDo.events;
  $: currentIndex = ($toDo.events || []).findLastIndex((x) => x.isCurrent) + 1;

  $: status = $toDo.candidateStatus;
  $: href = $toDo.campaignId ? `/campaign?campaignId=${$toDo.campaignId}` : "";

  const currentDate = numericDateString(Date.now() / 1000).replace(/-/g, "");

  // AI ToDos have dueDate
  // ignore notBefore since visibleFrom >= notBefore (todo_visible_from in BE)
  $: dueDate = $toDo.visibleFrom || $toDo.dueDate || null;
  $: overdue =
    dueDate && numericDateString(dueDate).replace(/-/g, "") < currentDate;
  $: formattedDueDate = dueDate ? formatDate(dueDate) : "";
</script>

<div class="info-heading">
  <div class="info-heading-group">
    <div class="info-heading-group-left">
      {#if (isOpportunity || isAiToDo || isManualToDo) && status}
        <span class="campaign-status">
          {status === "active" ? "Active" : "Finished"} on
        </span>
      {/if}
      {#if href}
        <a
          {href}
          class="campaign-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {$toDo.campaignName || ""}
        </a>
      {:else}
        <span class="no-campaign">Not active on a campaign</span>
      {/if}
      {#if renderStepInfo}
        <div class="separator"></div>
        {#if currentIndex > 0 && $toDo.events?.length}
          <span class="to-do-step"
            >Step {currentIndex}/{$toDo.events?.length}</span
          >
        {/if}
      {/if}
    </div>
    <div class="info-heading-group-right">
      {#if isBounce}
        <span>Bounced on {formatDate($toDo.visibleFrom)}</span>
      {:else if isOpportunity}
        {#if $toDo.snoozedTime}
          <Icon class="fa-zzz color-textGrey" />
          <span class="snoozed-on-span">snoozed on {$toDo.snoozedTime}</span>
          <div class="separator"></div>
        {/if}
        <span>Opportunity added {$toDo.opportunityTime}</span>
      {:else}
        <span class={overdue ? "overdue" : ""}>Due {formattedDueDate}</span>
      {/if}
    </div>
  </div>
</div>
